import React, { useEffect } from "react";

export default function ErrorModal({ message, onClose, title = "Error", okText = "OK" }) {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-2xl bg-white shadow-2xl ring-1 ring-black/5 dark:bg-zinc-900"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-black/10 px-5 py-4 dark:border-white/10">
          <h3 className="text-lg font-extrabold text-dark-green dark:text-white">
            {title}
          </h3>
          <button
            className="text-3xl leading-none text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <div className="px-5 py-4 text-slate-700 dark:text-slate-200">
          {typeof message === "string" ? <p>{message}</p> : message}
        </div>

        <div className="flex justify-end gap-2 border-t border-black/10 px-5 py-4 dark:border-white/10">
          <button
            className="rounded-xl bg-primary px-5 py-2.5 font-bold text-white hover:brightness-95 active:scale-[0.98]"
            onClick={onClose}
          >
            {okText}
          </button>
        </div>
      </div>
    </div>
  );
}